import * as React from "react";

function TrashCanIcon(props) {
	return (
		<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...props}>
			<path d="M3 6h18" />
			<path d="M8 6V4a1 1 0 011-1h6a1 1 0 011 1v2" />
			<path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" />
			<path d="M10 11v6M14 11v6" />
		</svg>
	);
}

export default TrashCanIcon;
